import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { setCurrentConfigCode, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import UserService from './UserService';

export default function LoginService() {
    const { promotionSlug } = useSelector(state => state.configurator);
    const dispatch = useDispatch();
    const userMutation = UserService();

    return useMutation(['loginQuery'], (payload) => {
        const loginConfigurationUrl = `${EndPoints.LoginUrl}/${promotionSlug}/login`;
        const data = {
            promotion_slug: promotionSlug,
            email: payload.email,
            password: payload.password,
        };

        console.log(data);

        axios
            .post(loginConfigurationUrl, data)
            .then((response) => {
                const saved = AccessTokenAuth.TrySaveAccessToken(response.headers.authorization);
                dispatch(setCurrentConfigCode(''));
                userMutation.mutate({});
                dispatch(setSnackbarMessage(FeedbackMessages.LoginSuccess));
            })
            .catch((error) => {
                console.log(error);
                payload.errorCallback();
            });
    });
}
